var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FAE506;}\n\t.st3{fill:#2F2C26;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.8,13.3c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7S10.2,13.3,8.8,13.3z M8.8,8.7 c-1.1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9S9.8,8.7,8.8,8.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.2,14.3c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7S17.7,14.3,16.2,14.3z M16.2,9.6 c-1.1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9S17.3,9.6,16.2,9.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19,20.4H6c-0.7,0-1.3-0.6-1.3-1.3v-2.3c0-2.2,1.8-4.1,3.9-4.2c1.2-0.1,2.4,0.4,3.2,1.3 c0.1,0.2,0.1,0.4,0,0.5c-0.2,0.1-0.4,0.1-0.5,0c-0.7-0.7-1.6-1.1-2.6-1.1c-1.8,0.1-3.2,1.6-3.2,3.5v2.3c0,0.3,0.2,0.6,0.6,0.6 h13c0.3,0,0.6-0.2,0.6-0.6v-1.4c0-1.8-1.4-3.4-3.2-3.5c-0.8,0-1.6,0.2-2.2,0.7c-0.2,0.1-0.4,0.1-0.5-0.1 c-0.1-0.2-0.1-0.4,0.1-0.5c0.8-0.6,1.7-0.9,2.7-0.8c2.2,0.1,3.9,2,3.9,4.2v1.4C20.3,19.8,19.7,20.4,19,20.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.5,18c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2s2.2,1,2.2,2.2S13.7,18,12.5,18z M12.5,14.3 c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5C14,14.9,13.3,14.3,12.5,14.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.9,20.4c-0.2,0-0.4-0.2-0.4-0.4c0-1.2-0.9-2.1-2.1-2.1s-2.1,0.9-2.1,2.1c0,0.2-0.2,0.4-0.4,0.4 s-0.4-0.2-0.4-0.4c0-1.6,1.3-2.8,2.8-2.8c1.6,0,2.8,1.3,2.8,2.8C15.3,20.3,15.2,20.4,14.9,20.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.5,8.9c-0.1,0-0.3-0.1-0.4-0.2l-1.4-1.4c-0.6-0.6-0.7-1.4-0.2-2c0.3-0.4,0.6-0.6,1.1-0.7 c0.3-0.1,0.7,0,1,0.2c0.3-0.2,0.7-0.2,1-0.2c0.4,0.1,0.8,0.3,1.1,0.7c0,0,0,0,0,0c0.4,0.6,0.3,1.5-0.2,2l-1.4,1.4 C12.8,8.8,12.6,8.9,12.5,8.9z M11.7,5.3c0,0-0.1,0-0.1,0c-0.2,0-0.4,0.2-0.6,0.4c-0.2,0.3-0.1,0.8,0.1,1.1l1.3,1.3l1.3-1.3 c0.3-0.3,0.4-0.8,0.1-1.1c-0.1-0.2-0.3-0.3-0.6-0.4c-0.2,0-0.5,0-0.7,0.2c-0.1,0.1-0.3,0.1-0.5,0C12.1,5.3,11.9,5.3,11.7,5.3z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.8,20.2H7.2c-0.6,0-1.1-0.5-1.1-1.1V5.8c0-0.6,0.5-1.1,1.1-1.1h9.6c0.6,0,1.1,0.5,1.1,1.1v2 c0,0.2-0.2,0.4-0.4,0.4s-0.4-0.2-0.4-0.4v-2c0-0.2-0.1-0.3-0.3-0.3H7.2C7,5.5,6.9,5.7,6.9,5.8v13.3c0,0.2,0.1,0.3,0.3,0.3h9.6 c0.2,0,0.3-0.1,0.3-0.3v-5.6c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v5.6C17.9,19.7,17.4,20.2,16.8,20.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.4,7.4H7.9C7.7,7.4,7.5,7.2,7.5,7s0.2-0.4,0.4-0.4h3.5c0.2,0,0.4,0.2,0.4,0.4S11.6,7.4,11.4,7.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.4,8.9H7.9c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h2.5c0.2,0,0.4,0.2,0.4,0.4S10.6,8.9,10.4,8.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.4,10.3H7.9c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h2.5c0.2,0,0.4,0.2,0.4,0.4S10.6,10.3,10.4,10.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.4,11.8H7.9c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h2.5c0.2,0,0.4,0.2,0.4,0.4S10.6,11.8,10.4,11.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.1,15.8H7.9c-0.2,0-0.4-0.2-0.4-0.4S7.7,15,7.9,15h8.2c0.2,0,0.4,0.2,0.4,0.4S16.3,15.8,16.1,15.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.1,17.3H7.9c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h8.2c0.2,0,0.4,0.2,0.4,0.4S16.3,17.3,16.1,17.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16.1,18.7H7.9c-0.2,0-0.4-0.2-0.4-0.4S7.7,18,7.9,18h8.2c0.2,0,0.4,0.2,0.4,0.4S16.3,18.7,16.1,18.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.8,12.5c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7S16.3,12.5,14.8,12.5z M14.8,7.9 c-1.1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9S15.9,7.9,14.8,7.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.8,13.5c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7c2,0,3.7,1.7,3.7,3.7S16.9,13.5,14.8,13.5z M14.8,6.9 c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9S16.5,6.9,14.8,6.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.6,10.8c-0.1,0-0.2,0-0.3-0.1l-0.6-0.6c-0.1-0.1-0.1-0.4,0-0.5c0.1-0.1,0.4-0.1,0.5,0l0.4,0.4L15.5,9 c0.1-0.1,0.4-0.1,0.5,0c0.1,0.1,0.1,0.4,0,0.5l-1.2,1.2C14.8,10.8,14.7,10.8,14.6,10.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.4,15.5c-0.3,0-0.5-0.1-0.7-0.3l-2.3-2.3c-0.1-0.1-0.1-0.4,0-0.5s0.4-0.1,0.5,0l2.3,2.3 c0.1,0.1,0.3,0.1,0.4,0l0.1-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1-0.1-0.2l-2.3-2.3c-0.1-0.1-0.1-0.4,0-0.5 c0.1-0.1,0.4-0.1,0.5,0l2.3,2.3c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7C20,15.4,19.7,15.5,19.4,15.5z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDades);
export default __webpack_public_path__ + "static/media/dades.9f07a8716a45545e4e95e8c001e95a6b.svg";
export { ForwardRef as ReactComponent };